import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";
import type { CreatePayloadContext } from "@/components/tables/genericCrudTable.createPayload";
import type { UpdatePayloadContext } from "@/components/tables/genericCrudTable.updatePayload";

const toNotePayload = (
  _result: any,
  values: any,
  ctx: CreatePayloadContext | UpdatePayloadContext
) => ({
  payload: values.payload === undefined ? "" : values.payload,
  entity_id: ctx.searchId,
  entity_type: "subject", // notes are only kept on the subject overview
});

export const noteEntityAdapter: EntityAdapter = {
  entity: "note",
  adjustCreatePayload: toNotePayload,
  adjustUpdatePayload: toNotePayload,
  searchIdParameter: "entity_id",
  searchAutoFocus: false,
  cellWhiteSpace: "break-spaces",
};
